<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <!-- Barra Superior Compacta -->
            <div class="row justify-content-between">
              <h5 class="col-md-1">Mapa</h5>
              <ol class="col-md-3 breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Hidrocarburos</li>
                <li class="breadcrumb-item active">Consultas</li>
                <li class="breadcrumb-item active">Mapas</li>
              </ol>
            </div>
            <div class="row form-group justify-content-center">
              <!-- Geocercas -->
              <label
                class="btn btn-outline-primary btn-sm m-0 mr-1"
                :class="{ 'btn-primary text-dark': form.geocercas }"
              >
                <input
                  type="checkbox"
                  id="geocercas"
                  v-model="form.geocercas"
                  @change="showGeocercas()"
                  class="d-none"
                />
                <i
                  class="fas fa-map-marked-alt mr-1"
                  :class="{ 'text-dark': form.geocercas }"
                ></i>
                Geocercas
              </label>
              <!-- Geocercas Prohibidas -->
              <label
                class="btn btn-outline-danger btn-sm m-0 mr-1"
                :class="{ 'btn-danger text-white': form.geocercasProhibidas }"
              >
                <input
                  type="checkbox"
                  id="geocercasProhibidas"
                  v-model="form.geocercasProhibidas"
                  @change="showGeocercasProhibidas()"
                  class="d-none"
                />
                <i
                  class="fas fa-ban mr-1"
                  :class="{ 'text-white': form.geocercasProhibidas }"
                ></i>
                Geocercas Prohibidas
              </label>
              <!-- Vehículos Activos -->
              <label
                class="btn btn-outline-success btn-sm m-0 mr-1"
                :class="{ 'btn-success text-white': form.carrosAct }"
              >
                <input
                  type="checkbox"
                  v-model="form.carrosAct"
                  @change="[(infoWinOpen = false), showCarros()]"
                  class="d-none"
                />
                <i
                  class="fas fa-truck-moving mr-1"
                  :class="{ 'text-white': form.carrosAct }"
                ></i>
                Activos
              </label>
              <!-- Vehículos Postulados -->
              <label
                class="btn btn-outline-warning btn-sm m-0 mr-1"
                :class="{ 'btn-warning text-dark': form.carrosPost }"
              >
                <input
                  type="checkbox"
                  v-model="form.carrosPost"
                  @change="[(infoWinOpen = false), showCarros()]"
                  class="d-none"
                />
                <i
                  class="fas fa-truck-moving mr-1"
                  :class="{ 'text-dark': form.carrosPost }"
                ></i>
                Postulados
              </label>
              <!-- Vehículos Inactivos -->
              <label
                class="btn btn-outline-danger btn-sm m-0 mr-1"
                :class="{ 'btn-danger text-white': form.carrosInact }"
              >
                <input
                  type="checkbox"
                  v-model="form.carrosInact"
                  @change="[(infoWinOpen = false), showCarros()]"
                  class="d-none"
                />
                <i
                  class="fas fa-truck-moving mr-1"
                  :class="{ 'text-white': form.carrosInact }"
                ></i>
                Inactivos
              </label>
            </div>
            <div class="row justify-content-center">
              <!-- Botón Buscar -->
              <button
                type="button"
                class="btn bg-lightblue btn-sm mr-1"
                data-toggle="modal"
                data-target="#modal_aside_mapa"
                @click="infoWinOpen = false"
              >
                <i class="fas fa-search-location mr-1"></i>
                Buscar
              </button>
              <!-- Actualizar -->
              <button
                type="button"
                class="btn bg-navy btn-sm mr-1"
                @click="showCarros()"
              >
                <i class="fas fa-sync mr-1"></i>
                Actualizar
              </button>
              <!-- Trazabilidad -->
              <button
                type="button"
                class="btn btn-outline-primary btn-sm mr-1"
                :class="{ 'btn-primary text-white': trazaViaje }"
                @click="toggleTrazabilidad"
              >
                <i
                  class="fas fa-route mr-1"
                  :class="{ 'text-white': trazaViaje }"
                ></i>
                Trazabilidad
              </button>
              <!-- Controles de Vista del Mapa -->
              <div class="btn-group btn-group-sm ml-3" role="group">
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  :class="{ active: !satelite }"
                  @click="satelite = false"
                >
                  <i class="fas fa-map mr-1"></i>
                  Mapa
                </button>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  :class="{ active: satelite }"
                  @click="satelite = true"
                >
                  <i class="fas fa-satellite mr-1"></i>
                  Satélite
                </button>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Contenedor del mapa -->
            <div class="row">
              <div class="col-md-12 mb-1">
                <div
                  class="map-wrapper shadow-sm rounded"
                  :class="{ fullscreen: mapFullscreen }"
                >
                  <button
                    type="button"
                    class="btn btn-dark btn-sm map-fullscreen-btn"
                    @click="toggleMapFullscreen"
                    :title="
                      mapFullscreen
                        ? 'Salir de pantalla completa'
                        : 'Pantalla completa'
                    "
                  >
                    <i
                      class="fas"
                      :class="mapFullscreen ? 'fa-compress' : 'fa-expand'"
                    ></i>
                  </button>
                  <gmap-map
                    :key="mapKey"
                    :center="center"
                    :zoom="zoom"
                    :map-type-id="satelite ? 'satellite' : 'roadmap'"
                    :style="{
                      width: '100%',
                      height: mapFullscreen ? '100vh' : '650px',
                    }"
                    :options="{
                      disableDefaultUI: true,
                      zoomControl: true,
                      mapTypeControl: true,
                      streetViewControl: true,
                    }"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markersTraza"
                      :position="m.position"
                      :icon="m.icon"
                      :animation="2"
                      @click="toggleInfoWindow(m, index, m.info)"
                    ></gmap-marker>
                    <gmap-cluster
                      :gridSize="50"
                      :zoomOnClick="true"
                      :enableRetinaIcons="true"
                      :minimumClusterSize="3"
                      :imagePath="'/img/map_cluster/m'"
                      ref="cluster"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :icon="m.icon"
                        :animation="2"
                        @click="toggleInfoWindow(m, index, m.info)"
                      ></gmap-marker>
                    </gmap-cluster>
                    <gmap-info-window
                      :options="infoOptions"
                      :position="infoWindowPos"
                      :opened="infoWinOpen"
                      @closeclick="infoWinOpen = false"
                    >
                      <div v-html="infoContent"></div>
                    </gmap-info-window>
                    <gmap-polygon
                      v-for="poligono in poligonos"
                      :options="{ fillColor: poligono.color }"
                      :key="poligono.id"
                      :paths="poligono.path"
                      :editable="false"
                      :draggable="false"
                      @click="
                        toggleInfoWindowPoli(
                          poligono,
                          poligono.id,
                          poligono.info
                        )
                      "
                    />
                    <gmap-circle
                      v-for="circular in circunferencias"
                      :key="circular.id"
                      :center="circular.center"
                      :radius="circular.radius"
                      :info="circular.info"
                      @click="
                        toggleInfoWindowCir(
                          circular,
                          circular.id,
                          circular.info
                        )
                      "
                    ></gmap-circle>
                    <gmap-polyline
                      v-for="(polyline, id) in polylinesMerged"
                      :key="id"
                      :path="polyline.path"
                      :options="polyline.options"
                      ref="polyline"
                      @click="
                        toggleInfoWindowPoli(
                          polyline,
                          id,
                          polyline.info != null ? polyline.info : ''
                        )
                      "
                    ></gmap-polyline>
                  </gmap-map>
                </div>
              </div>
              <!-- Ventana Flotante de Trazabilidad -->
              <div
                class="trazabilidad-floating-window"
                :class="{ dragging: isDragging }"
                v-if="trazaViaje"
                :style="{
                  left: windowPosition.x + 'px',
                  top: windowPosition.y + 'px',
                }"
                @mousedown="startDrag"
              >
                <div class="floating-window-content">
                  <!-- Header de la Ventana Flotante -->
                  <div
                    class="floating-header card-header bg-geogo-top-left text-white pb-2"
                  >
                    <h5 class="card-title">
                      <i class="fas fa-route mr-2"></i>
                      Trazabilidad de Vehículos
                    </h5>
                    <div class="card-tools">
                      <div class="btn-group mr-2" role="group">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          @click="showTraza()"
                          v-if="!$v.filter.$invalid"
                        >
                          <i class="fas fa-search"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="limpiarForm()"
                        >
                          <i class="fas fa-eraser"></i>
                        </button>
                        <button
                          v-if="puntosTraza.length > 0"
                          type="button"
                          class="btn btn-success btn-sm"
                          @click="generarTrazaExcel()"
                        >
                          <i class="far fa-file-excel"></i>
                        </button>
                      </div>
                      <span
                        v-if="markersPuntosNovedad.length > 0"
                        class="badge bg-warning text-dark mr-2"
                      >
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        {{ markersPuntosNovedad.length }}
                      </span>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm mr-2"
                        @click="trazabilidadCollapsed = !trazabilidadCollapsed"
                        :title="trazabilidadCollapsed ? 'Expandir' : 'Colapsar'"
                      >
                        <i
                          :class="
                            trazabilidadCollapsed
                              ? 'fas fa-chevron-down'
                              : 'fas fa-chevron-up'
                          "
                        ></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="toggleTrazabilidad"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <!-- Cuerpo de la Ventana Flotante -->
                  <div
                    class="floating-body p-3 bg-light card-body"
                    v-show="!trazabilidadCollapsed"
                  >
                    <!-- Fila principal: Buscar por + Campo de búsqueda -->
                    <div class="row align-items-start">
                      <!-- Select Buscar por -->
                      <div class="form-group col-md-6">
                        <label class="form-label mb-1 small">
                          Buscar por:
                        </label>
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend">
                            <span class="input-group-text bg-light"
                              ><i class="fas fa-search text-muted"></i
                            ></span>
                          </div>
                          <v-select
                            class="form-control form-control-xs p-0 w-90"
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            v-model="filter.buscar_por"
                            label="buscar_por"
                            :options="listasForms.buscar_por"
                            :reduce="(o) => o.buscar_por"
                            @input="limpiarForm()"
                          ></v-select>
                        </div>
                        <!-- Mensajes informativos -->
                        <div class="row mb-3">
                          <div v-if="filter.placa" class="col-12">
                            <small
                              v-if="
                                filter.placa &&
                                filter.periodo &&
                                filter.periodo !== 'personalizado'
                              "
                              class="text-success"
                            >
                              <i class="fas fa-check-circle mr-1"></i> Búsqueda
                              automática activada
                            </small>
                            <small
                              v-if="filter.mensaje_tiempo"
                              class="text-info d-block"
                            >
                              <i class="fas fa-clock mr-1"></i>
                              {{ filter.mensaje_tiempo }}
                            </small>
                          </div>
                        </div>
                      </div>

                      <!-- Campo de búsqueda dinámico -->
                      <div class="form-group col-md-6" v-if="filter.buscar_por">
                        <!-- Campo Placa -->
                        <div v-if="filter.buscar_por === 'Placa'">
                          <label class="form-label mb-1 small">
                            <i class="fas fa-truck text-primary mr-1"></i>
                            Vehículo
                          </label>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <span class="input-group-text bg-light">
                                <i class="fas fa-truck text-muted"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'border-primary':
                                  filter.placa &&
                                  filter.periodo &&
                                  filter.periodo !== 'personalizado',
                              }"
                              placeholder="Ingrese la placa del vehículo"
                              v-model="filter.placa"
                              @keypress.enter="onPlacaChange"
                            />
                          </div>
                        </div>

                        <!-- Campo Viaje -->
                        <div v-if="filter.buscar_por === 'Viaje'">
                          <label class="form-label mb-1 small">
                            <i
                              class="fas fa-map-marked-alt text-primary mr-1"
                            ></i>
                            Viaje
                          </label>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <span class="input-group-text bg-light">
                                <i class="fas fa-map-marked-alt text-muted"></i>
                              </span>
                            </div>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              placeholder="Viaje"
                              v-model="filter.viaje_id"
                              @keypress.enter="showTraza()"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!filter.buscar_por" class="row">
                      <div class="col-12">
                        <div class="alert alert-info border-0 py-2 mb-3">
                          <i class="fas fa-info-circle mr-2"></i>
                          <strong>Seleccione un método de búsqueda</strong> para
                          realizar la trazabilidad de un vehículo o un viaje.
                        </div>
                      </div>
                    </div>
                    <!-- Sección de fechas para Placa -->
                    <template v-if="filter.buscar_por === 'Placa'">
                      <!-- Períodos Rápidos -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <label class="form-label text-dark mb-2 small">
                            <i
                              class="fas fa-calendar-alt text-primary mr-1"
                            ></i>
                            Período
                          </label>
                          <div class="row">
                            <div class="col-12 mb-2">
                              <div class="btn-group w-100" role="group">
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{ active: filter.periodo === 'hoy' }"
                                  @click="setPeriodo('hoy')"
                                >
                                  <i class="fas fa-calendar-day mr-1"></i> Hoy
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{ active: filter.periodo === 'ayer' }"
                                  @click="setPeriodo('ayer')"
                                >
                                  <i class="fas fa-calendar-minus mr-1"></i>
                                  Ayer
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{
                                    active: filter.periodo === 'semana',
                                  }"
                                  @click="setPeriodo('semana')"
                                >
                                  <i class="fas fa-calendar-week mr-1"></i>
                                  Semana
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Botón para fecha personalizada -->
                          <div
                            class="text-center"
                            v-if="filter.periodo !== 'personalizado'"
                          >
                            <button
                              type="button"
                              class="btn btn-link btn-sm text-muted p-0"
                              @click="setPeriodo('personalizado')"
                            >
                              <i class="fas fa-cog mr-1"></i> Fecha
                              personalizada
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- Campos de Fecha Manual (Colapsable) -->
                      <div
                        class="row mt-3"
                        v-if="filter.periodo === 'personalizado'"
                      >
                        <!-- Fecha y Hora Inicio -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label fw-bold text-dark mb-2">
                            <i class="fas fa-play-circle text-success mr-1"></i>
                            Inicio
                          </label>
                          <div class="row">
                            <div class="col-7">
                              <input
                                type="date"
                                v-model="filter.fecha_inicio"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                :max="new Date().toISOString().split('T')[0]"
                                placeholder="Fecha"
                              />
                            </div>
                            <div class="col-5">
                              <input
                                type="time"
                                v-model="filter.hora_inicio"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                placeholder="Hora"
                              />
                            </div>
                          </div>
                        </div>
                        <!-- Fecha y Hora Fin -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label fw-bold text-dark mb-2">
                            <i class="fas fa-stop-circle text-danger mr-1"></i>
                            Fin
                          </label>
                          <div class="row">
                            <div class="col-7">
                              <input
                                type="date"
                                v-model="filter.fecha_fin"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                :max="new Date().toISOString().split('T')[0]"
                                placeholder="Fecha"
                              />
                            </div>
                            <div class="col-5">
                              <input
                                type="time"
                                v-model="filter.hora_fin"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                placeholder="Hora"
                              />
                            </div>
                          </div>
                        </div>
                        <!-- Botón para volver a fechas rápidas -->
                        <div class="col-12 text-center">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm"
                            @click="setPeriodo('hoy')"
                          >
                            <i class="fas fa-arrow-left mr-1"></i> Volver a
                            fechas rápidas
                          </button>
                        </div>
                      </div>
                    </template>

                    <!-- Información del Vehículo Compacta -->
                    <div v-if="vehiculoTraza" class="card">
                      <div class="card-header bg-lightblue border-0 py-2 m-0">
                        <div class="row align-items-center">
                          <div class="col-md-8">
                            <h6 class="mb-0">
                              <i class="fas fa-info-circle mr-2"></i>
                              Información del Vehículo
                            </h6>
                          </div>
                          <div class="col-md-4 text-right">
                            <span
                              v-if="vehiculoTraza.empresa"
                              class="badge bg-geogo text-white"
                            >
                              {{ vehiculoTraza.empresa.razon_social }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body py-3">
                        <div class="row align-items-center">
                          <!-- Información Principal Compacta -->
                          <div class="col-lg-6 mb-2">
                            <div class="d-flex align-items-center mb-2">
                              <div
                                class="bg-primary text-white rounded-circle p-2 mr-3"
                              >
                                <i class="fas fa-truck"></i>
                              </div>
                              <div>
                                <h5 class="mb-0 text-dark">
                                  {{ vehiculoTraza.placa }}
                                </h5>
                                <small
                                  v-if="vehiculoTraza.tipo_vehiculo"
                                  class="text-muted"
                                >
                                  {{ vehiculoTraza.tipo_vehiculo.nombre }}
                                </small>
                              </div>
                            </div>

                            <!-- Detalles del Vehículo Compactos -->
                            <div class="row">
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nMarca"
                              >
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-trademark text-primary me-1"
                                  ></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Marca</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nMarca
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nCombustible"
                              >
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-gas-pump text-success me-1"
                                  ></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Combustible</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nCombustible
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nTipoCarroceria"
                              >
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-truck text-info me-1"></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Carrocería</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nTipoCarroceria
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Estadísticas Compactas -->
                          <div class="col-lg-6 mb-2">
                            <div class="row">
                              <div class="col-6 mb-2">
                                <div class="text-center p-2 bg-light rounded">
                                  <i
                                    class="fas fa-map-marker-alt text-primary fa-lg mb-1"
                                  ></i>
                                  <h6 class="mb-0 text-dark">
                                    {{ puntosTraza.length }}
                                  </h6>
                                  <small class="text-muted">Puntos</small>
                                </div>
                              </div>
                              <div class="col-6 mb-2">
                                <div class="text-center p-2 bg-light rounded">
                                  <i
                                    class="fas fa-exclamation-triangle fa-lg mb-1"
                                    :class="
                                      markersPuntosNovedad.length > 0
                                        ? 'text-warning'
                                        : 'text-success'
                                    "
                                  ></i>
                                  <h6
                                    class="mb-0"
                                    :class="
                                      markersPuntosNovedad.length > 0
                                        ? 'text-warning'
                                        : 'text-success'
                                    "
                                  >
                                    {{ markersPuntosNovedad.length }}
                                  </h6>
                                  <small class="text-muted">Novedades</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado de la Trazabilidad Compacto -->
                        <div class="row mt-2">
                          <div class="col-12">
                            <div
                              v-if="puntosTraza.length > 0"
                              class="alert alert-default-success border-0 py-2"
                            >
                              <div class="row align-items-center">
                                <div class="col-md-8">
                                  <i class="fas fa-check-circle mr-2"></i>
                                  <strong>Trazabilidad completa:</strong>
                                  {{ puntosTraza.length }} puntos
                                  automáticamente.
                                </div>
                                <div class="col-md-4 text-right">
                                  <small class="text-muted">
                                    <i
                                      class="fas fa-map-marker-alt text-success mr-1"
                                    ></i>
                                    Inicio:
                                    {{
                                      puntosTraza[0]?.dteFechaReporte || "N/A"
                                    }}
                                    <br />
                                    <i
                                      class="fas fa-flag-checkered text-danger mr-1"
                                    ></i>
                                    Fin:
                                    {{
                                      puntosTraza[puntosTraza.length - 1]
                                        ?.dteFechaReporte || "N/A"
                                    }}
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div
                              v-else
                              class="alert alert-warning border-0 py-2 m-0"
                            >
                              <i class="fas fa-exclamation-triangle mr-2"></i>
                              No se encontró trazabilidad para el vehículo
                              dentro de los parámetros seleccionados.
                            </div>
                          </div>
                        </div>

                        <!-- Formulario de vista de puntos de GPS en el mapa -->
                        <div
                          v-if="puntosTraza.length > 0"
                          class="form-group custom-control custom-switch"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="switchTraza"
                            v-model="trazaSegmentada"
                            @change="getTrazaSegmentada()"
                          />
                          <label class="custom-control-label" for="switchTraza"
                            >Ver trazabilidad
                            {{
                              trazaSegmentada ? "segmentada" : "completa"
                            }}</label
                          >
                        </div>
                        <div
                          v-if="puntosTraza.length > 0 && !trazaSegmentada"
                          class="row"
                        >
                          <div class="form-group col-md-6">
                            <label class="form-label mb-1 small"
                              >Cantidad de puntos a mostrar</label
                            >
                            <input
                              type="number"
                              min="1"
                              class="form-control form-control-sm"
                              placeholder="Cantidad Puntos"
                              v-model="filter.cantidad"
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <br />
                            <div
                              class="btn-group float-right pt-1"
                              role="group"
                              v-if="puntosTraza[0] && filter.cantidad"
                            >
                              <button
                                type="button"
                                class="btn bg-info border-light"
                                id="atras"
                                :disabled="!markersTraza[1] || !filter.cantidad"
                                @click="backPoint()"
                              >
                                <i class="fas fa-angle-double-left"></i>
                              </button>
                              <button
                                type="button"
                                class="btn bg-info border-light"
                                id="adelante"
                                :disabled="
                                  markersTraza.length >= puntosTraza.length ||
                                  !filter.cantidad
                                "
                                @click="nextPoint()"
                              >
                                <i class="fas fa-angle-double-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12" v-if="puntosTraza.length > 0">
                            <div class="progress progress-sm">
                              <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                :style="{ width: progresoTraza + '%' }"
                                :aria-valuenow="progresoTraza"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <small class="text-muted"
                                >Progreso trazabilidad</small
                              >
                              <small class="text-muted">
                                {{ markersTraza.length }} /
                                {{ puntosTraza.length }} ({{ progresoTraza }}%)
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- fin Información del Vehículo Compacta -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Complemento del mapa e informacion de vehiculos -->
            <div class="row form-group justify-content-center text-lg">
              <div class="badge bg-white shadow-sm m-1 p-0">
                <div class="row justify-content-between pl-2 pr-2">
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-map-marked-alt p-1 text-danger"></i>
                    <strong>Sitio</strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-map-marked-alt p-1 text-primary"></i>
                    <strong>Punto Gestión</strong>
                  </div>
                </div>
              </div>
              <div
                v-if="form.carrosAct"
                class="badge bg-white shadow-sm m-1 p-0"
              >
                <div class="row justify-content-between pl-2 pr-2">
                  <div class="badge bg-light border m-1">
                    <input
                      type="checkbox"
                      class="form form-xs m-0"
                      v-model="form.carrosGuias"
                      @change="showCarros()"
                      :disabled="form.carrosViajes || form.carrosTickets"
                    />
                    <i class="fas fa-truck-moving ml-2 mr-2 text-success"></i>
                    <strong>Con Guía: {{ cantGuias }}</strong>
                  </div>
                  <div class="badge bg-light border m-1">
                    <input
                      type="checkbox"
                      class="form form-xs m-0"
                      v-model="form.carrosTickets"
                      @change="showCarros()"
                      :disabled="form.carrosViajes || form.carrosGuias"
                    />
                    <i class="fas fa-truck-moving ml-2 mr-2 text-indigo"></i>
                    <strong>Con Ticket: {{ cantTickets }}</strong>
                  </div>
                  <div class="badge bg-light border m-1">
                    <input
                      type="checkbox"
                      class="form form-xs m-0"
                      v-model="form.carrosViajes"
                      @change="showCarros()"
                      :disabled="form.carrosGuias || form.carrosTickets"
                    />
                    <i class="fas fa-truck-moving ml-2 mr-2 text-info"></i>
                    <strong>Con Viaje Activo: {{ cantViajes }}</strong>
                  </div>
                </div>
              </div>
              <div class="badge bg-white shadow-sm m-1 p-0">
                <div class="row justify-content-between pl-2 pr-2">
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-warning"></i>
                    <strong>Con Viaje Finalizado: {{ cantInactViaje }}</strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-danger"></i>
                    <strong>Sin Viaje Activo: {{ cantInact }}</strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-primary"></i>
                    <strong>Postulado: {{ cantPost }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <template
              v-if="
                Object.keys(vehiculosAct).length > 0 ||
                Object.keys(vehiculosPost).length > 0 ||
                Object.keys(vehiculosInact).length > 0
              "
            >
              <MapasListVehiculos ref="MapasListVehiculos" />
            </template>
          </div>
        </section>
        <MapasOptions
        ref="MapasOptions"
        @update-rutas-polylines="onUpdateRutasPolylines"
      />
        <ViajesDetViaje ref="ViajesDetViaje" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  getRotacionFlechaTraza,
  calcularBearingGrados,
  parseCoordGps,
  parseHeadingGps,
} from "@/utils/trazaGps";
import vSelect from "vue-select";
import MapasOptions from "./MapasOptions";
import MapasListVehiculos from "./MapasListVehiculos";
import ViajesDetViaje from "../viajes/ViajesDetViaje";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import Loading from "../../../../components/Loading";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import { required } from "vuelidate/lib/validators";
// import RutaPolilineasVue from "../../../admin/basico/rutas/RutaPolilineas.vue";

export default {
  name: "Mapas",

  components: {
    Loading,
    MapasOptions,
    MapasListVehiculos,
    ViajesDetViaje,
    GmapCluster,
    vSelect,
  },

  data() {
    return {
      cargando: false,
      satelite: false,
      isDragging: false,
      windowPosition: { x: 20, y: 20 },
      markersPuntosNovedad: [],
      dragOffset: { x: 0, y: 0 },
      trazabilidadCollapsed: false,
      vehiculoTraza: null,
      searchTimeout: null,
      dias_limite: 7,

      vehiculosAct: {},
      vehiculosInact: {},
      vehiculosPost: {},
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        geocercas: false,
        geocercasProhibidas: false,
        carrosAct: false,
        carrosInact: false,
        carrosPost: false,
        carrosGuias: false,
        carrosTickets: false,
        carrosViajes: false,
      },
      filter: {
        buscar_por: "Placa",
        placa: null,
        fecha_inicio: null,
        fecha_fin: null,
        hora_inicio: null,
        hora_fin: null,
        viaje_id: null,
        mensaje_tiempo: null,
        limite_registros: null,
        periodo: null,
        cantidad: null,
      },
      trazaSegmentada: true,
      listasForms: {
        empresas: [],
        estados: [],
        estadosPostulacion: [],
        origenes: [],
        destinos: [],
        rutas: [],
        productos: [],
        tipos_combustibles: [],
        buscar_por: [{ buscar_por: "Placa" }, { buscar_por: "Viaje" }],
      },
      colorsArray: [
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#16DEC3",
        "#5B0823",
      ],
      colors: {},
      mapKey: 0,
      center: { lat: 4.651371, lng: -74.071509 },
      zoom: 6,
      markers: [],
      markersTraza: [],
      places: [],
      currentPlace: null,
      locations: {},
      mapFullscreen: false,
      poligonos: [],
      circunferencias: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      viajes: [],
      trazaViaje: false,
      path: [],
      det_ruta: [],
      polylines: {},
      polylinesRutasTramos: {},
      pathPoli: [],
      polylineOptions: [],
      cantGuias: 0,
      cantTickets: 0,
      cantViajes: 0,
      cantPost: 0,
      cantInact: 0,
      cantInactViaje: 0,
    };
  },

  computed: {
    polylinesMerged() {
      return { ...this.polylines, ...this.polylinesRutasTramos };
    },
    progresoTraza() {
      const total = this.puntosTraza.length || 0;
      if (!total) return 0;
      const avance = this.markersTraza.length || 0;
      const pct = Math.floor((avance / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
  },

  validations() {
    let filter = [];
    switch (this.filter.buscar_por) {
      case "Placa":
        filter = {
          placa: {
            required,
          },
          fecha_inicio: {
            required,
          },
          fecha_fin: {
            required,
          },
          hora_inicio: {
            required,
          },
          hora_fin: {
            required,
          },
        };
        break;
      case "Viaje":
        filter = {
          viaje_id: {
            required,
          },
        };
        break;
      default:
        filter = {
          buscar_por: {
            required,
          },
        };
        break;
    }
    return { filter };
  },

  methods: {
    // ==================== MÉTODO PRINCIPAL - getIndex ====================
    async getIndex(page = 1) {
      this.cargando = true;
      let filters = this.$refs.MapasOptions.filter;
      if (
        Object.keys(this.vehiculosAct).length > 0 ||
        Object.keys(this.vehiculosPost).length > 0 ||
        Object.keys(this.vehiculosInact).length > 0
      ) {
        let filters2 = this.$refs.MapasListVehiculos.filtros;
        Object.assign(filters, filters2);
      }
      filters.carrosAct = this.form.carrosAct;
      filters.carrosInact = this.form.carrosInact;
      filters.carrosPost = this.form.carrosPost;
      filters.carrosViajes = this.form.carrosViajes;
      filters.carrosGuias = this.form.carrosGuias;
      filters.carrosTickets = this.form.carrosTickets;

      await axios
        .get("/api/hidrocarburos/mapas?page=" + page, {
          params: filters,
        })
        .then((response) => {
          this.vehiculosAct = response.data[0];
          this.vehiculosInact = response.data[1];
          this.vehiculosPost = response.data[2];
          this.cargando = false;
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    // ==================== MÉTODOS QUE CARGAN LISTAS ====================
    getEmpresa() {
      axios.get("/api/admin/empresas/lista").then((response) => {
        this.listasForms.empresas = response.data;
      });
    },

    getOrigenes() {
      axios.get("/api/admin/sitios/lista").then((response) => {
        this.listasForms.origenes = response.data;
      });
    },

    getDestinos() {
      axios.get("/api/admin/sitios/lista").then((response) => {
        this.listasForms.destinos = response.data;
      });
    },

    getRutas() {
      axios.get("/api/admin/rutas/lista").then((response) => {
        this.listasForms.rutas = response.data;
      });
    },

    getProductos() {
      axios.get("/api/hidrocarburos/Productos/lista").then((response) => {
        this.listasForms.productos = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/39").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getTiposCombustibles() {
      axios.get("/api/lista/24").then((response) => {
        this.listasForms.tipos_combustibles = response.data;
      });
    },

    getEstadosPostulacion() {
      axios.get("/api/lista/65").then((response) => {
        this.listasForms.estadosPostulacion = response.data;
      });
    },

    // ==================== MÉTODOS QUE AFECTAN EL MAPA ====================
    async showDraggable() {
      if (await this.trazaViaje) {
        $("#trazaViaje").css("display", "block");
        $("#trazaViaje").draggable();
      } else {
        $("#trazaViaje").css("display", "none");
      }
    },
    toggleTrazabilidad() {
      this.trazaViaje = !this.trazaViaje;
      this.showDraggable();
    },
    generarTrazaExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/mapas/exportTraza",
        data: { filtros: this.filter },
      })
        .then((response) => {
          let data = response.data;
          if (data.msj) {
            this.$swal({
              icon: "error",
              title: data.msj,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          } else {
            this.cargando = false;
            location.href = data.url;
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    pintarPolylineTraza() {
      const path = [];
      for (let i = 0; i < this.puntosTraza.length; i++) {
        const lat = parseFloat(this.puntosTraza[i].latitud);
        const lng = parseFloat(this.puntosTraza[i].longitud);
        if (!isNaN(lat) && !isNaN(lng)) {
          path.push({ lat: lat, lng: lng });
        }
      }
      if (path.length > 1) {
        this.$set(this.polylines, "trazaVehiculo", {
          path: path,
          options: {
            strokeColor: "#1976d2",
            strokeWeight: 4,
            strokeOpacity: 0.85,
            geodesic: true,
          },
          info: "",
        });
        this.center = path[path.length - 1];
        this.zoom = 12;
      } else if (this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
    },

    getTrazaSegmentada() {
      this.pintarPolylineTraza();
      this.markersTraza = [];
      if (!this.puntosTraza.length) {
        return;
      }
      const me = this;
      const indices = [];
      if (this.trazaSegmentada) {
        const maxMarkers = 200;
        const total = this.puntosTraza.length;
        if (total <= maxMarkers) {
          for (let i = 0; i < total; i++) {
            indices.push(i);
          }
        } else {
          const step = (total - 1) / (maxMarkers - 1);
          for (let i = 0; i < maxMarkers; i++) {
            indices.push(Math.round(i * step));
          }
        }
      } else {
        indices.push(0);
        this.filter.cantidad = null;
      }

      const chunkSize = 40;
      let pos = 0;
      const gen = (this._trazaPaintGen = (this._trazaPaintGen || 0) + 1);
      const pintarChunk = function () {
        if (gen !== me._trazaPaintGen) {
          return;
        }
        const end = Math.min(pos + chunkSize, indices.length);
        for (; pos < end; pos++) {
          const i = indices[pos];
          const marker = {
            lat: parseFloat(me.puntosTraza[i].latitud),
            lng: parseFloat(me.puntosTraza[i].longitud),
          };
          me.markersTraza.push({
            id: me.puntosTraza[i].id,
            position: marker,
            info: me.buildVentanaTraza(me.puntosTraza[i]),
            icon: me.getSvgIconViaje(i),
          });
        }
        if (pos < indices.length) {
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(pintarChunk);
          } else {
            setTimeout(pintarChunk, 0);
          }
        }
      };
      pintarChunk();
    },
    buildVentanaTraza(punto) {
      if (!punto) return "";
      if (punto.ventana) return punto.ventana;
      const placa =
        punto.placa || (this.vehiculoTraza && this.vehiculoTraza.placa) || "";
      const transp =
        punto.transportadora ||
        (this.vehiculoTraza &&
          this.vehiculoTraza.empresa &&
          this.vehiculoTraza.empresa.razon_social) ||
        "";
      const distancia =
        punto.distancia != null ? punto.distancia : punto.intDistanciaRecorrida || "";
      return (
        '<div style="padding:8px;min-width:220px;max-width:320px">' +
        "<strong>🚛 " +
        placa +
        "</strong><br>" +
        "<small><b>Fecha:</b> " +
        (punto.dteFechaReporte || "") +
        "</small><br>" +
        "<small><b>Posición:</b> " +
        (punto.latitud || "") +
        ", " +
        (punto.longitud || "") +
        "</small><br>" +
        "<small><b>Velocidad:</b> " +
        (punto.velocidad != null ? punto.velocidad : "") +
        " Km/h</small><br>" +
        "<small><b>Transportadora:</b> " +
        transp +
        "</small><br>" +
        "<small><b>Distancia:</b> " +
        distancia +
        "</small>" +
        "</div>"
      );
    },
    nextPoint() {
      let dist =
        parseInt(this.markersTraza.length - 1) + parseInt(this.filter.cantidad);
      for (let i = this.markersTraza.length - 1; i < dist; i++) {
        if (this.markersTraza.length < this.puntosTraza.length) {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.buildVentanaTraza(this.puntosTraza[i]),
            icon: this.getSvgIconViaje(i),
          });
          this.center = marker;
          this.zoom = 13;
        } else {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.buildVentanaTraza(this.puntosTraza[i]),
            icon: this.getSvgIconViaje(i),
          });
          this.$swal({
            title: "Fin del recorrido!",
            text: "No se encontraron más tramas para este viaje",
            icon: "info",
          });

          break;
        }
      }
    },
    backPoint() {
      let dist =
        parseInt(this.markersTraza.length - 1) - parseInt(this.filter.cantidad);
      for (let i = this.markersTraza.length - 1; i > dist; i--) {
        this.markersTraza.splice(i, 1);
      }
      this.center = {
        lat: parseFloat(
          this.markersTraza[this.markersTraza.length - 1].position.lat
        ),
        lng: parseFloat(
          this.markersTraza[this.markersTraza.length - 1].position.lng
        ),
      };
    },
    // Función para calcular la dirección entre dos puntos usando coordenadas
    getDireccion(index) {
      const punto = this.puntosTraza[index];
      if (!punto) return 0;

      const heading = parseHeadingGps(
        punto.intHeading != null ? punto.intHeading : punto.direccion
      );
      if (heading != null) {
        return heading;
      }

      return getRotacionFlechaTraza(this.puntosTraza, index) + 180;
    },
    calcularDireccion(lat1, lon1, lat2, lon2) {
      return calcularBearingGrados(
        parseCoordGps(lat1),
        parseCoordGps(lon1),
        parseCoordGps(lat2),
        parseCoordGps(lon2)
      );
    },
    getSvgIconViaje(index) {
      const google = window.google;
      const puntoTraza = this.puntosTraza[index];
      const esPrimerPunto = index === 0;
      const esUltimoPunto = index === this.puntosTraza.length - 1;
      const velocidad = parseFloat(puntoTraza.velocidad || 0);

      let svgPath = "";

      // SVG de Inicio de Ruta (primer punto) - bandera verde, más destacada que el resto
      if (esPrimerPunto) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
            <circle cx="28" cy="28" r="27" fill="#fff" stroke="#28a745" stroke-width="3"/>
            <line x1="28" y1="44" x2="28" y2="12" stroke="#5a6268" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M 28 12 L 28 28 L 46 20 Z" fill="#28a745" stroke="#1e7e34" stroke-width="1.5"/>
            <circle cx="28" cy="44" r="3" fill="#28a745"/>
          </svg>
        `;
      }
      // SVG de Final de Ruta (último punto) - bandera roja, más destacada que el resto
      else if (esUltimoPunto) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
            <circle cx="28" cy="28" r="27" fill="#fff" stroke="#dc3545" stroke-width="3"/>
            <line x1="28" y1="44" x2="28" y2="12" stroke="#5a6268" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M 28 12 L 28 28 L 46 20 Z" fill="#dc3545" stroke="#c82333" stroke-width="1.5"/>
            <circle cx="28" cy="44" r="3" fill="#dc3545"/>
          </svg>
        `;
      }
      // SVG de Stop (velocidad = 0)
      else if (velocidad === 0) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <polygon points="20,4 32,12 32,28 20,36 8,28 8,12" 
              fill="#dc3545" 
              stroke="#fff" 
              stroke-width="2"/>
            <text x="20" y="25" text-anchor="middle" fill="#fff" font-family="Arial, sans-serif" font-size="8" font-weight="bold">STOP</text>
          </svg>
        `;
      }
      // SVG de Vehículo en Movimiento (con dirección)
      else {
        const direccion = this.getDireccion(index);
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
            <circle cx="15" cy="15" r="13.5" stroke="#ffffff" stroke-width="3" fill="#0066cc"></circle>
            <path fill="#ff4444" stroke="#ffffff" stroke-width="1.5" d="M 9 9 L 15 12 L 21 9 L 15 24 Z"
              transform="rotate(${direccion - 180}, 15, 15)"
            ></path>
          </svg>
        `;
      }

      const encodedPath = encodeURIComponent(svgPath);
      const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

      // Inicio (bandera verde) y final (bandera roja): más grandes; resto de puntos: tamaño normal
      const isInicio = esPrimerPunto;
      const isFinal = esUltimoPunto;
      const isDestacado = isInicio || isFinal;
      const scale = isDestacado ? 1.35 : 0.8;
      const anchor = isDestacado
        ? new google.maps.Point(28, 28)
        : new google.maps.Point(20, 20);

      return {
        url: iconUrl,
        fillColor: isInicio ? "#28a745" : isFinal ? "#dc3545" : "#b0c442",
        fillOpacity: 1,
        strokeColor: isInicio ? "#1e7e34" : isFinal ? "#c82333" : "#00529c",
        strokeWeight: isDestacado ? 2 : 1,
        strokeOpacity: 0.7,
        rotation: 0,
        scale,
        anchor,
      };
    },
    limpiarMapa() {
      this.puntosTraza = [];
      this.markersTraza = [];
      this.viajes = [];
      this.infoWinOpen = false;
    },
    pintarMarcadoresHidroEnChunks(puntos) {
      const chunkSize = 80;
      const me = this;
      const gen = this._mapaPaintGen;
      return new Promise(function (resolve) {
        let i = 0;
        const pintarChunk = function () {
          if (gen !== me._mapaPaintGen) {
            resolve();
            return;
          }
          const end = Math.min(i + chunkSize, puntos.length);
          for (; i < end; i++) {
            const loc1 = puntos[i];
            const marker = {
              lat: parseFloat(loc1.lat),
              lng: parseFloat(loc1.lon),
            };
            me.markers.push({
              position: marker,
              icon: me.getSvgIcon(loc1),
              info: loc1.ventana,
              center: {
                marker: marker,
              },
            });
          }
          if (i < puntos.length) {
            if (window.requestAnimationFrame) {
              window.requestAnimationFrame(pintarChunk);
            } else {
              setTimeout(pintarChunk, 0);
            }
          } else {
            resolve();
          }
        };
        pintarChunk();
      });
    },
    async showCarros() {
      this._mapaPaintGen = (this._mapaPaintGen || 0) + 1;
      this.markers = [];
      let filters = this.$refs.MapasOptions.filter;
      filters.carrosAct = await this.form.carrosAct;
      filters.carrosInact = await this.form.carrosInact;
      filters.carrosPost = await this.form.carrosPost;
      filters.carrosViajes = await this.form.carrosViajes;
      filters.carrosGuias = await this.form.carrosGuias;
      filters.carrosTickets = await this.form.carrosTickets;
      if (filters.geocerca != null) {
        this.filterResult(filters.geocerca);
      }
      this.cargando = true;
      if (
        this.form.carrosAct ||
        this.form.carrosInact ||
        this.form.carrosPost
      ) {
        this.cantGuias = 0;
        this.cantTickets = 0;
        this.cantViajes = 0;
        this.cantInact = 0;
        this.cantInactViaje = 0;
        this.cantPost = 0;
        const me = this;
        await axios
          .get("/api/hidrocarburos/mapas/showCarros", {
            params: filters,
          })
          .then(async (response) => {
            this.getIndex();
            let loc = response.data;
            this.cantGuias = loc[1];
            this.cantTickets = loc[2];
            this.cantViajes = loc[3];
            this.cantInact = loc[4];
            this.cantInactViaje = loc[5];
            this.cantPost = loc[6];
            this.det_ruta = loc[7];
            if (this.det_ruta.length > 0) {
              await this.RutaPolilineas();
            }
            this.cargando = false;
            await this.pintarMarcadoresHidroEnChunks(loc[0] || []);
          })
          .catch(function (error) {
            me.cargando = false;
            me.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      } else {
        this.getIndex();
      }
    },
    filterResult(geo) {
      for (let i = 0; i < this.poligonos.length; i++) {
        if (this.poligonos[i].id == geo.id) {
          const marker = {
            lat: parseFloat(this.poligonos[i].path[0].lat),
            lng: parseFloat(this.poligonos[i].path[0].lng),
          };
          this.markersTraza.push({
            position: marker,
            info: this.poligonos[i].info,
          });
          this.center = marker;
          this.zoom = 15;
        }
      }
    },
    cleanMarkers() {
      this.markersTraza = [];
    },
    getSvgIcon(data) {
      const google = window.google;

      const path = `
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
          <circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="${
            data.icon_color
          }"></circle>
          <path 
            fill="#b0c442"
            stroke="white" 
            stroke-width="1" 
            d="M 7 7 L 13 11 L 19 7 L 13 21 Z" 
            transform="rotate(${
              data.direccion ? data.direccion - 180 : -180
            }, 13, 13)">
          </path>
          <rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
          <text font-size="10" font-family="" x="28" y="16" fill="white">
            ${data.desc}
          </text>
        </svg>
      `;
      const encodedPath = encodeURIComponent(path);
      const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

      return {
        url: iconUrl,
        fillColor: "#b0c442",
        fillOpacity: 1,
        strokeColor: "#00529c",
        strokeWeight: 1,
        strokeOpacity: 0.7,
        rotation: data.direccion ? data.direccion - 180 : -180,
        scale: 0.7,
        anchor: new google.maps.Point(15, 30),
      };
    },
    async showGeocercas() {
      if (await this.form.geocercas) {
        this.cargando = true;
        await axios
          .get("/api/hidrocarburos/mapas/showGeocercas")
          .then((response) => {
            this.cargando = false;
            this.locations = response.data.gps_fin;
            this.locations.geocerca_poli.forEach((geocerca) => {
              if (geocerca.puntos.length > 0) {
                let puntos = [];
                geocerca.puntos.forEach((punto) => {
                  puntos.push({
                    lng: parseFloat(punto.longitud),
                    lat: parseFloat(punto.latitud),
                  });
                });

                this.poligonos.push({
                  id: geocerca.id,
                  name: geocerca.desc,
                  path: puntos,
                  info: geocerca.ventana,
                  color: geocerca.color,
                });
              }
            });
            for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
              if (this.locations.geocerca_cir[j]["lat"] !== "") {
                this.circunferencias.push({
                  center: {
                    lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                    lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                  },
                  radius: parseFloat(this.locations.geocerca_cir[j]["radio"]),
                  info: this.locations.geocerca_cir[j]["ventana"],
                });
              }
            }
          })
          .catch(function (error) {
            this.cargando = false;
          });
      } else {
        this.locations = {};
        this.circunferencias = [];
        this.poligonos = [];
      }
    },
    async showGeocercasProhibidas() {
      if (await this.form.geocercasProhibidas) {
        this.cargando = true;
        await axios
          .get("/api/hidrocarburos/mapas/showGeocercasProhibidas")
          .then((response) => {
            this.cargando = false;
            this.locations = response.data.gps_fin;
            this.locations.geocerca_poli.forEach((geocerca) => {
              if (geocerca.puntos.length > 0) {
                let puntos = [];
                geocerca.puntos.forEach((punto) => {
                  puntos.push({
                    lng: parseFloat(punto.longitud),
                    lat: parseFloat(punto.latitud),
                  });
                });

                this.poligonos.push({
                  id: geocerca.id,
                  name: geocerca.desc,
                  path: puntos,
                  info: geocerca.ventana,
                  color: geocerca.color,
                });
              }
            });
            for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
              if (this.locations.geocerca_cir[j]["lat"] !== "") {
                this.circunferencias.push({
                  center: {
                    lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                    lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                  },
                  radius:
                    parseFloat(this.locations.geocerca_cir[j]["radio"]) * 1000,
                  info: this.locations.geocerca_cir[j]["ventana"],
                });
              }
            }
          })
          .catch(function (error) {
            this.cargando = false;
          });
      } else {
        this.locations = {};
        this.circunferencias = [];
        this.poligonos = [];
      }
    },
    toggleInfoWindow: function (marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //comprueba si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    toggleInfoWindowPoli: function (poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    toggleInfoWindowCir: function (cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    // ==================== MÉTODOS RELACIONADOS CON LA VENTANA FLOTANTE ====================
    // Métodos para el arrastre de la ventana flotante
    startDrag(event) {
      // Solo permitir arrastre desde el header
      if (!event.target.closest(".floating-header")) return;

      this.isDragging = true;
      this.dragOffset.x = event.clientX - this.windowPosition.x;
      this.dragOffset.y = event.clientY - this.windowPosition.y;

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);

      // Prevenir selección de texto durante el arrastre
      event.preventDefault();
    },
    onDrag(event) {
      if (!this.isDragging) return;

      const newX = event.clientX - this.dragOffset.x;
      const newY = event.clientY - this.dragOffset.y;

      // Limitar el movimiento dentro de los límites de la ventana
      const maxX = window.innerWidth - 600; // Ancho de la ventana
      const maxY = window.innerHeight - 200; // Altura mínima visible

      this.windowPosition.x = Math.max(0, Math.min(newX, maxX));
      this.windowPosition.y = Math.max(0, Math.min(newY, maxY));
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    onPlacaChange() {
      // Limpiar timeout anterior si existe
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      // Búsqueda automática si hay período seleccionado y placa (solo para fechas rápidas)
      if (
        this.filter.placa &&
        this.filter.periodo &&
        this.filter.periodo !== "personalizado"
      ) {
        // Pequeño delay para evitar búsquedas excesivas mientras el usuario escribe
        this.searchTimeout = setTimeout(() => {
          this.showTraza();
        }, 1000);
      }
    },
    setPeriodo(periodo) {
      this.$set(this.filter, "periodo", periodo);

      const ahora = new Date();
      const hoy = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate()
      );

      let mensajeTiempo = "Carga óptima (< 2 segundos)";

      switch (periodo) {
        case "hoy":
          mensajeTiempo = "Carga óptima (< 5 segundos)";
          this.$set(this.filter, "fecha_inicio", this.formatDate(hoy));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          break;

        case "ayer": {
          mensajeTiempo = "Carga óptima (< 15 segundos)";
          const ayer = new Date(hoy);
          ayer.setDate(ayer.getDate() - 1);
          this.$set(this.filter, "fecha_inicio", this.formatDate(ayer));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(ayer));
          this.$set(this.filter, "hora_fin", "23:59");
          break;
        }
        case "semana": {
          // 7 días calendario inclusivos (hoy + 6 previos) para no superar el tope de 7 días
          mensajeTiempo = "Carga óptima (< 30 segundos)";
          const semanaAtras = new Date(hoy);
          semanaAtras.setDate(semanaAtras.getDate() - 6);
          this.$set(this.filter, "fecha_inicio", this.formatDate(semanaAtras));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          break;
        }
        case "personalizado": {
          const ayerPersonalizado = new Date(hoy);
          ayerPersonalizado.setDate(ayerPersonalizado.getDate() - 1);
          this.$set(this.filter, "fecha_inicio", this.formatDate(ayerPersonalizado));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          mensajeTiempo = "Máximo 7 días — Carga óptima (< 30 segundos)";
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
          }
          break;
        }
        default:
          mensajeTiempo = "Carga óptima (< 2 segundos)";
          break;
      }

      this.$set(this.filter, "mensaje_tiempo", mensajeTiempo);

      // Si hay placa, hacer búsqueda automática
      if (this.filter.placa && periodo !== "personalizado") {
        this.showTraza();
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    limpiarForm() {
      this.filter.placa = null;
      this.filter.fecha_inicio = null;
      this.filter.fecha_fin = null;
      this.filter.hora_inicio = null;
      this.filter.hora_fin = null;
      this.filter.viaje_id = null;
      this.filter.mensaje_tiempo = null;
      this.filter.limite_registros = null;
      this.filter.periodo = null;
      this.vehiculoTraza = null;
      this.markersTraza = [];
      this.puntosTraza = [];
      this.markersPuntosNovedad = [];
      this._trazaPaintGen = (this._trazaPaintGen || 0) + 1;
      if (this.polylines && this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
      this.center = { lat: 4.651371, lng: -74.071509 };
      this.zoom = 6;
      this.infoWinOpen = false;
    },
    showTraza() {
      // Método para mostrar la trazabilidad de un vehículo optimizada
      this.cargando = true;
      this.vehiculoTraza = null;
      this.markersTraza = [];
      this.puntosTraza = [];
      this.markersPuntosNovedad = [];
      this._trazaPaintGen = (this._trazaPaintGen || 0) + 1;
      if (this.polylines && this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
      this.center = { lat: 4.651371, lng: -74.071509 };
      this.zoom = 6;

      // Mostrar mensaje de progreso según el período
      let mensajeProgreso = "Buscando trazabilidad...";
      if (this.filter.mensaje_tiempo) {
        mensajeProgreso = `Buscando trazabilidad - ${this.filter.mensaje_tiempo}`;
      }

      const swalMsg = this.$swal({
        title: mensajeProgreso,
        text:
          this.filter.buscar_por === "Placa"
            ? `Período: ${this.filter.fecha_inicio} ${this.filter.hora_inicio} - ${this.filter.fecha_fin} ${this.filter.hora_fin}`
            : `Viaje: ${this.filter.viaje_id}`,
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      axios
        .get("/api/hidrocarburos/mapas/trazaViaje", {
          params: this.filter,
        })
        .then((response) => {
          this.cargando = false;
          swalMsg.close(); // Cerrar modal de progreso

          if (!response.data.mensaje) {
            if (response.data.arregloViaje) {
              this.filter.vehiculo_id = "";
              this.puntosTraza = response.data.arregloViaje;
              this.vehiculoTraza = response.data.vehiculoTraza;

              if (this.puntosTraza.length > 0) {
                this.getTrazaSegmentada();
              } else {
                this.$swal({
                  icon: "error",
                  title:
                    "No existe traza para este Vehículo en las fechas seleccionadas.",
                  toast: true,
                  position: "top-end",
                  timer: 3500,
                  timerProgressBar: true,
                  showConfirmButton: false,
                });
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: response.data.mensaje,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3500,
              timerProgressBar: true,
            });
            return false;
          }
        })
        .catch((error) => {
          this.cargando = false;
          swalMsg.close(); // Cerrar modal de progreso
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    validaFechas() {
      if (
        this.filter.fecha_inicio &&
        this.filter.hora_inicio &&
        this.filter.fecha_fin &&
        this.filter.hora_fin
      ) {
        const fecha_menor = new Date(
          this.filter.fecha_inicio + " " + this.filter.hora_inicio
        );
        const fecha_mayor = new Date(
          this.filter.fecha_fin + " " + this.filter.hora_fin
        );

        if (fecha_menor > fecha_mayor) {
          this.filter.fecha_fin = null;
          this.filter.hora_fin = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio no puede ser mayor a la Fecha Fin...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return false;
        }

        const diff = fecha_mayor - fecha_menor;
        const fecha_limite = diff / (1000 * 60 * 60 * 24);
        if (fecha_limite > this.dias_limite) {
          this.filter.fecha_fin = null;
          this.filter.hora_fin = null;
          this.$swal({
            icon: "error",
            title: `La diferencia de fechas no puede ser mayor a ${this.dias_limite} días...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return false;
        }
      }
    },
    // ==================== MÉTODOS RELACIONADOS CON LA VENTANA FLOTANTE ====================

    // ==================== MÉTODOS RELACIONADOS CON COMPONENTES HIJOS ====================
    onUpdateRutasPolylines(polylinesObj) {
      this.polylinesRutasTramos = polylinesObj || {};
      this.mapKey++;
    },
    async RutaPolilineas() {
      this.polylines = {};
      this.pathPoli = await this.det_ruta;

      for (let r = 0; r < this.pathPoli.length; r++) {
        const ruta = this.pathPoli[r];
        const color = this.colorsArray[r % this.colorsArray.length]; // selecciona un color diferente para cada polilínea

        const polyline = {
          path: [], // construye el arreglo de puntos de la polilínea
          options: {
            strokeColor: color,
            strokeOpacity: 0.5,
            strokeWeight: 6,
          },
        };
        if (this.pathPoli[r].ruta_polilineas.length > 0) {
          // agrega cada punto de la ruta al arreglo de puntos de la polilínea
          for (let i = 0; i < this.pathPoli[r].ruta_polilineas.length; i++) {
            if (i == 0) {
              const punto = this.pathPoli[r].ruta_polilineas[i];
              polyline.path.push({
                lat: parseFloat(punto.lat_ini),
                lng: parseFloat(punto.lon_ini),
              });
            }
            const punto = this.pathPoli[r].ruta_polilineas[i];
            polyline.path.push({
              lat: parseFloat(punto.lat_fin),
              lng: parseFloat(punto.lon_fin),
            });
          }
          // agrega la polilínea al objeto de polilíneas, utilizando el ID de la ruta como clave
          this.$set(this.polylines, ruta.id, polyline);
        }
      }
      this.mapKey++; // aumenta la clave del mapa
    },
    toggleMapFullscreen() {
      this.mapFullscreen = !this.mapFullscreen;
      this.$nextTick(() => {
        // Forzar relayout del mapa al cambiar tamaño
        this.mapKey += 1;
      });
    },
    // ==================== FIN DE MÉTODOS RELACIONADOS CON COMPONENTES HIJOS ====================
  },

  beforeMount() {
    this.getEmpresa();
    this.getOrigenes();
    this.getDestinos();
    this.getRutas();
    this.getEstados();
    this.getTiposCombustibles();
    this.getEstadosPostulacion();
    this.getProductos();
  },
};
</script>
<style>
/* Ventana flotante de trazabilidad - Funcionalidad única */
.trazabilidad-floating-window {
  position: fixed;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  z-index: 1050;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #dee2e6;
  overflow: hidden;
  user-select: none;
  animation: slideInFromRight 0.3s ease-out;
}

.floating-window-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.floating-header {
  cursor: move;
}

.floating-body {
  overflow-y: auto;
  flex: 1;
  max-height: 85vh;
}

/* Arrastre activo */
.trazabilidad-floating-window.dragging {
  cursor: move;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
}

/* Animación de entrada */
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Pantalla completa del mapa - Funcionalidad única */
.map-wrapper.fullscreen {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
  background: #fff;
}

.map-fullscreen-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

/* Responsive optimizado */
@media (max-width: 768px) {
  .trazabilidad-floating-window {
    top: 10px;
    right: 10px;
    left: 10px;
    width: auto;
    max-width: none;
  }
}
</style>
